import moment from "moment";

const getTags = (occasions) => {
  if (!occasions || occasions.length < 1) return [];
  let tags = [];
  occasions.forEach((o) => {
    o.activity.tags.forEach((t) => {
      if (!tags.includes(t)) {
        tags = [...tags, t];
      }
    });
  });
  return tags.sort();
};

const getWeekdays = (occasions, locale) => {
  if (!occasions || occasions.length < 1) return [];
  let weekdays = [];
  occasions.forEach((o) => {
    let weekday = moment(o.at).locale(locale).format("dddd");
    if (!weekdays.includes(weekday)) {
      weekdays = [...weekdays, weekday];
    }
  });
  return weekdays;
};

const getActivities = (occasions) => {
  if (!occasions || occasions.length < 1) return [];
  let activities = [];
  occasions.forEach((o) => {
    let activity = o.activity.name;
    if (!activities.includes(activity)) {
      activities = [...activities, activity];
    }
  });
  return activities;
};

const getLocations = (occasions) => {
  if (!occasions || occasions.length < 1) return [];
  let locations = [];
  occasions.forEach((o) => {
    let location = o.activity.location.name;
    if (!locations.includes(location)) {
      locations = [...locations, location];
    }
  });
  return locations;
};

export const getFilterData = (week, locale) => {
  const occasions = week.occasions.filter((o) =>
    moment(o.at).isAfter(moment())
  );
  return {
    locations: getLocations(occasions),
    activities: getActivities(occasions),
    weekdays: getWeekdays(occasions, locale),
    tags: getTags(occasions),
  };
};

const groupOccasions = (occasions, locale) => {
  let groupedOccasions = [];
  let weekdays = [];
  occasions.forEach((o) => {
    const weekday = moment(o.at).locale(locale).format("dddd");
    if (!weekdays.includes(weekday)) {
      weekdays = [...weekdays, weekday];
    }
  });
  weekdays.forEach((w) => {
    const grouped = occasions.filter((o) => o.weekday === w);
    groupedOccasions = [
      ...groupedOccasions,
      { weekday: w, occasions: grouped },
    ];
  });
  return groupedOccasions;
};

export const getFilteredOccasions = (occasions, filter, culture) => {
  const locale = culture.substring(0, 2).toLowerCase();
  const locations = () => {
    if (filter.locations.length > 0) {
      return occasions.filter((o) =>
        filter.locations.includes(o.activity.location.name)
      );
    }
    return occasions;
  };

  const activities = () => {
    const occasions = locations();
    if (filter.activities.length > 0) {
      return occasions.filter((o) =>
        filter.activities.includes(o.activity.name)
      );
    }
    return occasions;
  };

  const weekdays = () => {
    const occasions = activities();
    if (filter.weekdays.length > 0) {
      return occasions.filter((o) => filter.weekdays.includes(o.weekday));
    }
    return occasions;
  };

  const tags = () => {
    const occasions = weekdays();
    if (filter.tags.length > 0) {
      return occasions.filter((o) => {
        let included = false;
        o.activity.tags.forEach((tag) => {
          if (filter.tags.includes(tag)) {
            included = true;
          }
        });
        return included;
      });
    }
    return occasions;
  };
  const filtered = tags();
  const sorted = filtered.sort((a, b) => new Date(a.at) - new Date(b.at));
  const grouped = groupOccasions(sorted, locale);
  return grouped;
};

export const getAllFilters = (filter) => {
  let filters = [];
  const filterTypes = Object.keys(filter);
  if (filterTypes.length < 1) return filters;
  filterTypes.forEach((t) => {
    let typeFilter = filter[t];
    typeFilter.forEach((f) => {
      filters = [...filters, { value: f, type: t, label: f }];
    });
  });
  return filters;
};
